import type { Content } from "@prismicio/client";
import { asText } from "@prismicio/helpers";
import { useMemo } from "react";
import { useCountdown, resolveLabels, buildParts } from "../useCountdown";

type Props = {
  slice: Content.CountdownTimerSliceBoxed;
};

const BoxedTimer = ({ slice }: Props) => {
  const title = asText(slice.primary.title);
  const timeLeft = useCountdown(slice.primary.target_date);

  const labels = useMemo(
    () => resolveLabels(slice.primary),
    [slice.primary],
  );

  const parts = buildParts(timeLeft, labels);

  return (
    <>
      {title && <h2 className="countdown-timer__title">{title}</h2>}

      <div className="countdown-timer__units">
        {parts.map((part, i) => (
          <div key={part.key} className="countdown-timer__unit">
            {i > 0 && <span className="countdown-timer__separator">:</span>}
            <div className="countdown-timer__cell">
              <span className="countdown-timer__value" suppressHydrationWarning>
                {part.value}
              </span>
              {slice.primary.show_labels !== false && (
                <p className="boxed-countdown-timer__label">{part.label}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default BoxedTimer;
